import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
export function TireSalesPage() {
  return <div data-id="element-1269">
      {/* Page Header */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden bg-black" data-id="element-1270">
        <img src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-25" data-id="element-1271" />
        <div className="relative z-10" data-id="element-1272">
          <p className="text-[#CC0000] font-bold text-sm uppercase tracking-widest mb-3" data-id="element-1273">
            Our Services
          </p>
          <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-1274">
            🛞 Tire Sales
          </h1>
          <div className="w-12 h-0.5 mx-auto mt-4 mb-4" style={{
          background: '#FECB00'
        }} data-id="element-1275" />
          <p className="text-gray-300 text-base max-w-xl mx-auto" data-id="element-1276">
            Top global brands for every vehicle — cars, SUVs, trucks, and more.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-1277">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-1278">
          <div data-id="element-1279">
            <h2 className="text-2xl sm:text-3xl font-black text-black mb-5" data-id="element-1280">
              The Right Tire for Every Road
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5" data-id="element-1281">
              At Ameritech Tires, we carry an extensive inventory of tires from
              the world's most trusted brands — Michelin, Goodyear, Bridgestone,
              Continental, Pirelli, and more. Whether you're looking for
              all-season reliability, high-performance grip, or winter-ready
              traction, we have the perfect tire for your vehicle and budget.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-1282">
              Our knowledgeable staff will walk you through your options,
              explain the differences, and help you make a confident, informed
              decision. No pressure, no upsells — just honest advice from people
              who know tires.
            </p>
          </div>

          {/* What's Included */}
          <div className="bg-[#F5F5F5] rounded-lg p-8" data-id="element-1283">
            <h3 className="font-black text-black text-xl mb-6" data-id="element-1284">
              What's Included
            </h3>
            <ul className="space-y-4" data-id="element-1285">
              <li className="flex items-start gap-3" data-id="element-1286">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1287" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1288">
                  Wide selection of all-season, performance, and winter tires
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1289">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1290" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1291">
                  Tires for cars, SUVs, trucks, vans, and commercial vehicles
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1292">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1293" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1294">
                  Top brands: Michelin, Goodyear, Bridgestone, Continental &amp;
                  more
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1295">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1296" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1297">
                  Budget-friendly options without sacrificing safety
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1298">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1299" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1300">
                  Free expert consultation to find the right fit
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1301">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1302" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1303">
                  Free tire rotation for life with every tire purchase
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why It Matters */}
      <section className="w-full bg-[#F5F5F5] py-16 px-4 sm:px-6 lg:px-8" data-id="element-1304">
        <div className="max-w-5xl mx-auto" data-id="element-1305">
          <h2 className="text-2xl sm:text-3xl font-black text-black mb-6 text-center" data-id="element-1306">
            Why Choosing the Right Tire Matters
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1307">
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1308">
              <div className="text-3xl mb-3" data-id="element-1309">🛡️</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1310">
                Safety First
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1311">
                The right tire dramatically improves braking distance, cornering
                stability, and wet-weather grip.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1312">
              <div className="text-3xl mb-3" data-id="element-1313">⛽</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1314">
                Fuel Efficiency
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1315">
                Low rolling resistance tires can improve your gas mileage by up
                to 4%, saving you money every mile.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1316">
              <div className="text-3xl mb-3" data-id="element-1317">💰</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1318">
                Long-Term Value
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1319">
                Quality tires last longer, wear more evenly, and protect your
                wheels and suspension from damage.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="w-full bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1320">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-1321">
          Ready to Find Your Perfect Tires?
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-1322">
          Visit any of our 3 DMV locations or book an appointment online today.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1323">
          <Link to="/contact" className="inline-flex items-center justify-center bg-[#CC0000] hover:bg-[#AA0000] text-white font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1324">
            Book an Appointment
          </Link>
          <Link to="/services" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1325">
            View All Services
          </Link>
        </div>
      </section>
    </div>;
}